var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page',{attrs:{"name":"Registration Link","use":"_id","display":_vm.display,"page-prefix":"/blade/registration-links","fetch":_vm.getRegistrationLinks,"remove":_vm.deleteRegistrationLink}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d76823","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blade/pages/RegistrationLinkList.vue
// module id = null
// module chunks = 